// @flow
import React from 'react'
import { Box, type boxProps } from 'frack-components'
import config from '../../../config.js'

type Props = boxProps

const Column = (props: Props) => <Box {...props} />

Column.defaultProps = {
  padding: config.gutter,
  width: '100%',
}

export default Column
